import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import DangerSVG from "assets/danger.svg";

interface ErrorTooltipProps {
    message: string;
}

export const ErrorTooltip: React.FC<ErrorTooltipProps> = ({ message }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        requestAnimationFrame(() => {
            setIsVisible(true);
        });
    }, []);

    return (
        <Tooltip $visible={isVisible}>
            <TooltipIcon>
                <DangerSVG />
            </TooltipIcon>
            <TooltipText>{message}</TooltipText>
        </Tooltip>
    );
};

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
`;

const slideInDesktop = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Tooltip = styled.div<{ $visible: boolean }>`
    position: absolute;
    bottom: calc(100% + 12px);
    right: 0;
    background: #E2E5FF;
    border: 1px solid #cdd2f6;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    max-width: 320px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 100;
    opacity: ${props => props.$visible ? 1 : 0};
    animation: ${slideInDesktop} 0.3s ease-out forwards;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        right: 20px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #E2E5FF;
    }

    @media (max-width: 768px) {
        left: 50%;
        right: auto;
        transform: translateX(-50%);
        max-width: calc(100vw - 48px);
        width: max-content;
        min-width: 280px;
        padding: 12px 14px;
        font-size: 12px;
        animation: ${slideIn} 0.3s ease-out forwards;

        &::after {
            left: 50%;
            right: auto;
            transform: translateX(-50%);
        }
    }
`;

const TooltipIcon = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;

    svg {
        width: 20px;
        height: 20px;
    }

    @media (max-width: 768px) {
        svg {
            width: 18px;
            height: 18px;
        }
    }
`;

const TooltipText = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: #000000;
    line-height: 1.4;
    font-family: SF Pro Display, sans-serif;

    @media (max-width: 768px) {
        font-size: 13px;
    }
`;
